import React from 'react';
import queryString from 'query-string';

import FormContainer from './FormContainer';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import { Container } from 'reactstrap';
import { AuthProvider } from '../../context/AuthContext';

// IMPORTS DE SERVICIOS:
import ServiceApi from '../../services/ServiceApi';

// IMPORTS DE ESTILOS E IMAGENES:
import './style.scss';


/**
 * Login Container
 * Componente principal para container de logins por pass o por code.
 *
 * @class Login
 * @extends {React.Component}
 */
class Login extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.api = new ServiceApi(this);
    this.userAuth = JSON.parse(localStorage.getItem('userAuth'));
  }

  _validateParams() {
    if (!this.parameters.client_id || !this.parameters.redirect_uri || !this.parameters.response_type) {
      return false;
    }

    return true;
  }

  render() {
    return (
      <div className="dokifun">
        <main>
          <AuthProvider initialUserAuth={this.userAuth}>
            <Container fluid className="p-0">
              {this._validateParams() ?
                <FormContainer api={this.api} location={this.props.location} /> :
                <RequestLoginErrorMessage
                  onlyMessage={true}
                  message="Parámetros Inválidos"
                />
              }
            </Container>
          </AuthProvider>
        </main>
      </div>
    );
  }
}

export default Login;
